export const API_URL = process.env.REACT_APP_API_URL;
export const UPLOADS_API_URL = process.env.REACT_APP_UPLOADS_API_URL;
export const UPLOADS_API_URL_DOCS = process.env.REACT_APP_UPLOADS_API_URL_DOCS;
export const JWT_SECRET = process.env.REACT_APP_JWT_SECRET;
